module.exports = __webpack_public_path__ + "static/img/u85.d5d367e3.png";